import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Package, ArrowLeft, LogIn } from 'lucide-react';
import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function MyOrdersPage() {
  const navigate = useNavigate();
  const { user, loading, login } = useAuth();
  const [orders, setOrders] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user) { setBusy(false); return; }
    axios.get(`${API}/my/orders`, { withCredentials: true })
      .then(r => setOrders(r.data))
      .catch(() => setOrders([]))
      .finally(() => setBusy(false));
  }, [user, loading]);

  return (
    <>
      <AnnouncementBar />
      <Header />
      <main className="max-w-[1000px] mx-auto px-4 md:px-8 py-10">
        <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 text-sm mb-6" style={{ color: 'var(--gk-green-dark)' }}>
          <ArrowLeft size={16} /> Home
        </button>
        <h1 className="font-serif text-3xl md:text-4xl font-bold mb-6" style={{ color: 'var(--gk-green-dark)' }}>My Orders</h1>

        {loading || busy ? (
          <p style={{ color: 'var(--gk-muted)' }}>Loading...</p>
        ) : !user ? (
          <div className="p-8 rounded-xl text-center" style={{ background: '#fff', border: '1px solid #ecdfc7' }}>
            <p className="mb-4" style={{ color: 'var(--gk-ink)' }}>Sign in to view your order history.</p>
            <button onClick={login} className="gk-btn-primary"><LogIn size={16} /> Sign in with Google</button>
          </div>
        ) : orders.length === 0 ? (
          <div className="p-8 rounded-xl text-center" style={{ background: '#fff', border: '1px solid #ecdfc7' }}>
            <Package size={40} className="mx-auto mb-3" style={{ color: 'var(--gk-green)' }} />
            <p className="mb-4" style={{ color: 'var(--gk-ink)' }}>You have not placed any orders yet.</p>
            <button onClick={() => navigate('/')} className="gk-btn-primary">Shop Spices</button>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map(o => (
              <div key={o.order_id} className="p-5 rounded-xl" style={{ background: '#fff', border: '1px solid #ecdfc7' }}>
                <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                  <div>
                    <div className="font-semibold" style={{ color: 'var(--gk-ink)' }}>Order {o.order_id}</div>
                    <div className="text-xs" style={{ color: 'var(--gk-muted)' }}>{new Date(o.created_at).toLocaleString('en-IN')}</div>
                  </div>
                  <span className="chip" style={{ background: 'var(--gk-cream-dark)', color: 'var(--gk-green-dark)' }}>{o.status}</span>
                </div>
                <div className="flex flex-wrap gap-3">
                  {o.items.slice(0, 4).map((it, i) => (
                    <div key={i} className="flex items-center gap-2 text-xs px-2 py-1 rounded" style={{ background: 'var(--gk-cream)' }}>
                      <img src={it.image} alt="" className="w-8 h-8 rounded object-cover" />
                      <span>{it.name} · {it.size} × {it.qty}</span>
                    </div>
                  ))}
                  {o.items.length > 4 && <span className="text-xs" style={{ color: 'var(--gk-muted)' }}>+{o.items.length - 4} more</span>}
                </div>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-sm" style={{ color: 'var(--gk-muted)' }}>Payment: Cash on Delivery</span>
                  <span className="font-bold" style={{ color: 'var(--gk-green-dark)' }}>₹{o.total}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
